/**
 * Main Entry Point
 * Initializes and renders the React application
 */

import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { AudioOutputDiagnostics } from '@/components/voice/AudioOutputDiagnostics';
import './styles/globals.css';

// Standalone probe for audio-output support, opened with ?audiodiag=1. Routed here
// rather than inside App so it never mounts the call machinery at all.
const isAudioDiag = new URLSearchParams(window.location.search).get('audiodiag') === '1';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    {isAudioDiag ? <AudioOutputDiagnostics /> : <App />}
  </React.StrictMode>
);
